export class HttpFieldModel {
    //There is only on property here because we may want to expand this model in future
    public Fields: Array<string>;    
}
